import React from "react";

const TopSection = () => {
  return (
    <div className="relative md:h-[30rem] h-[35rem] w-full">
      <img
        src="/image-fix/random-images/r21.jpg"
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />
      <div className="absolute inset-0 bg-black opacity-50 z-10"></div>
      <div className="relative z-30 h-full flex flex-col justify-center max-w-3xl mx-auto space-y-2">
        <div>
          <h1 className="text-white text-2xl md:text-3xl font-bold p-4 ">
            Executive Education for Foreign Ministry Staff, Embassy Personnel,
            and International Relations Professionals
          </h1>
        </div>

        <div className="md:flex md:space-x-3 mx-3">
          <div className="md:w-1/2">
            <div className="space-y-1 ">
              <div className="bg-black font-bold bg-opacity-50 w-1/2 text-[#B8DAFF] text-sm md:text-base p-2 border-b border-[#B8DAFF] inline-block">
                <p>Faculty</p>
              </div>
              <div className="bg-black bg-opacity-50 text-white text-sm md:text-base p-2 border-b border-white">
                <p>International Relations, Diplomacy & Politics</p>
              </div>
            </div>

            <div className="space-y-1">
              <div className="bg-black font-bold bg-opacity-50 w-1/2 text-[#B8DAFF] text-sm md:text-base p-2 border-b border-[#B8DAFF] inline-block">
                <p>Credits</p>
              </div>
              <div className="bg-black bg-opacity-50 text-white text-sm md:text-base p-2 border-b border-white">
                <p>8 ECTS</p>
              </div>
            </div>
          </div>

          <div className="bg-sdbodywhite w-0.5 hidden md:block"></div>

          <div className="md:w-1/2">
            <div className="space-y-1">
              <div className="bg-black font-bold bg-opacity-50 w-1/2 text-[#B8DAFF] mt-1 md:mt-0 text-sm md:text-base p-2 border-b border-[#B8DAFF] inline-block">
                <p>Language</p>
              </div>
              <div className="bg-black bg-opacity-50 text-white text-sm md:text-base p-2 border-b border-white">
                <p>English</p>
              </div>
            </div>

            <div className="space-y-1">
              <div className="bg-black font-bold bg-opacity-50 w-1/2 text-[#B8DAFF] text-sm md:text-base p-2 border-b border-[#B8DAFF] inline-block">
                <p>Country</p>
              </div>
              <div className="bg-black bg-opacity-50 text-white text-sm md:text-base p-2 border-b border-white">
                <p>Europe/Asia</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
